// imports
import MenuOverlay from 'minsky-kit/js/components/MenuOverlay';
import { svgIconEl } from 'minsky-kit/js/utils/svgIcon';
// private statics

// class definition
export default class WADMenuOverlay extends MenuOverlay {
    // constructor
    constructor(args = {}, objectName = 'MenuOverlay') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        // set properties
        this._$header = args.$header;

        // prep
        prepEl.call(this);
        updateHeaderHeight.call(this);

        // this.show();

        // add listeners
        this.$el.querySelectorAll('a').forEach(($a) => {
            $a.addEventListener('click', this.blm.addOnce('onLinkClick', onLinkClick));
        });
    }

    // methods
    refresh(...args) {
        super.refresh(...args);
        updateHeaderHeight.call(this);
    }

    show(...args) {
        super.show(...args);
        updateHeaderHeight.call(this);
    }

    destroy() {
        // remove listeners
        this.$el.querySelectorAll('a').forEach(($a) => {
            $a.removeEventListener('click', this.blm.get('onLinkClick'));
        });

        cleanUp.call(this);
        super.destroy();
    }

    // getters & setters
}

// Utils
function prepEl() {
    const $arrowSvg = svgIconEl('arrow-right', ['menu__arrow']);

    Array.from(this.$el.querySelectorAll('.menu--main .menu__link')).forEach(($item) => {
        $item.prepend($arrowSvg.cloneNode(true));
    });

    const $contactBtn = this.$el.querySelector('.header__contact-btn > .button');
    if ($contactBtn) {
        $contactBtn.classList.remove('button--c-genoa-to-easternblue');
        $contactBtn.classList.add('button--c-easternblue-to-iceberg');
    }
}

function cleanUp() {
    this.$el.querySelectorAll('.menu__arrow').forEach(($arrow) => {
        $arrow.remove();
    });

    const $contactBtn = this.$el.querySelector('.header__contact-btn > .button');
    if ($contactBtn) {
        $contactBtn.classList.remove('button--c-easternblue-to-iceberg');
        $contactBtn.classList.add('button--c-genoa-to-easternblue');
    }
}

function updateHeaderHeight() {
    const container = this.$el.querySelector('.overlay__container');
    container.style.paddingTop = this._$header ? `${this._$header.clientHeight}px` : null;
}

function onLinkClick() {
    this.hide();
}

// Event handlers
